<!--begin::App Wrapper-->
<div class="app-wrapper">
  <!--begin::Header-->
  <nav class="app-header navbar navbar-expand bg-body" main-header>
  </nav>
  <!--end::Header-->
  <!--begin::Sidebar-->
  <aside class="app-sidebar shadow custom-sidebar" data-bs-theme="dark" main-sidebar>
  </aside>
  <!--end::Sidebar-->
  <!--begin::App Main-->
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row align-items-center px-3">
          <div class="col-md-7">
            <div class="section-title">
              <i [ngClass]="currentIcon + ' ' + 'text-primary'" class="nav-icon fs-4"></i>
              <h3>
                @if (clientCompanyName) {
                  {{clientCompanyName+ ' Project'}}
                }
                @if (!clientCompanyName && isManagementPage) {
                  {{section}} {{managementAction}}
                }
                @if (!clientCompanyName && !isManagementPage) {
                  {{subsection ? subsection :
                  section}}
                }
              </h3>
              @if (relatedCodeItem) {
                <span
                class="badge bg-primary-subtle text-primary text-uppercase ms-2 badge-section">{{relatedCodeItem}}</span>
              }
              @if (relatedClientName) {
                <span
                class="badge bg-primary-subtle text-primary text-uppercase ms-2 badge-section">{{relatedClientName}}</span>
              }
              @if (relatedBrandName) {
                <span
                class="badge bg-primary-subtle text-primary text-uppercase ms-2 badge-section">{{relatedBrandName}}</span>
              }
            </div>
          </div>
          <div class="col-md-5">
            @if (breadcrumbs?.length) {
              <ol class="breadcrumb float-md-end mb-0">
                <li class="breadcrumb-item">
                  <i class="bi bi-house-door text-primary me-1"></i>
                  <a routerLink="/" class="text-decoration-none">Home</a>
                </li>
                @for (crumb of breadcrumbs; track $index; let last = $last) {
                  @if (crumb.routerLink && !last) {
                    <li class="breadcrumb-item">
                      <a [routerLink]="crumb.routerLink" class="text-decoration-none">{{ crumb.label }}</a>
                    </li>
                  } @else {
                    <li class="breadcrumb-item" [class.active]="last" [attr.aria-current]="last ? 'page' : null">{{ crumb.label }}</li>
                  }
                }
              </ol>
            } @else if (section) {
              <ol class="breadcrumb float-md-end mb-0">
                <li class="breadcrumb-item">
                  <i class="bi bi-house-door text-primary me-1"></i>
                  <a routerLink="/app" class="text-decoration-none">Home</a>
                </li>
                @if (!subsection && !isManagementPage) {
                  <li class="breadcrumb-item active"
                  aria-current="page">{{section}}</li>
                }
                @if (subsection || isManagementPage) {
                  <li class="breadcrumb-item">
                    <i class="bi bi-table text-primary me-1 small"></i>
                    <a [routerLink]="'/app/' + section.toLowerCase()"
                    class="text-decoration-none">{{section}}</a>
                  </li>
                }
                @if (subsection) {
                  <li class="breadcrumb-item active" aria-current="page">
                    <i class="bi bi-gear-fill text-primary me-1 small"></i>
                    {{subsection}}
                  </li>
                }
                @if (isManagementPage) {
                  <li class="breadcrumb-item active" aria-current="page">
                    <i class="bi bi-pencil-square text-primary me-1 small"></i>
                    {{section}} Management
                  </li>
                }
              </ol>
            }
          </div>
        </div>
        <!--end::Row-->
        @if (isScopeChangePage) {
          <div class="row px-3 mt-1">
            <div class="col-12 text-center">
              <span
                class="badge bg-warning text-primary text-uppercase badge-section badge-blink"
                [id]="'scopeChangeBadge'" #scopeChangeBadge>Change of Scope</span>
            </div>
          </div>
        }
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
  <!--end::App Main-->
  <!--begin::Footer-->
  <footer class="app-footer">
    <!--begin::To the end-->

    <!--end::To the end-->
    <!--begin::Copyright-->
    <strong>
      Copyright &copy; 2020-2026&nbsp;
      <a href="https://global-lab.eu" class="text-decoration-none">Global Lab Ltd</a>.
    </strong>
    All rights reserved.
    <!--end::Copyright-->
  </footer>
  <!--end::Footer-->
</div>
<!--end::App Wrapper-->